# This directive scrolls element to the bottom.
# Using of the listener is because the element has to be visible when listener catches an event.
# Usage: <ul class="options-list" scroll-to-bottom>
angular.module('rjmNg.directives').directive "scrollToBottom", [
  "$timeout"
  (
    $timeout
  ) ->
    restrict: "A"
    link: (scope, element, attr) ->

      _scrollToBottom = () ->
        $timeout(() -> element.scrollTop(element[0].scrollHeight))

      scrollToBottomListener = scope.$on("scrollToBottom", _scrollToBottom)

      _cleanUp = () ->
        scrollToBottomListener()
        return

      scope.$on('$destroy', _cleanUp)
]